module.exports = __webpack_public_path__ + "img/server-1.06586758.webp";